// extracted by mini-css-extract-plugin
export var downArrow = "_jn-0";
export var infoTooltipIcon = "_jn-3";
export var label = "_jn-1";
export var optionCard = "_jn-4";
export var upArrow = "_jn-2";